"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useJobState = void 0;
const react_1 = require("react");
const job_status_types_1 = require("../../../types/job-status.types");
const useJobState = (jobStatus) => {
    return (0, react_1.useMemo)(() => {
        if (!jobStatus) {
            return {
                isCompleted: false,
                isFailed: false,
                isActive: false,
                isWaiting: false,
                isNotFound: false,
            };
        }
        return {
            isCompleted: jobStatus.status === job_status_types_1.JobStatusEnum.COMPLETED && !jobStatus?.result?.bledyImportu,
            isFailed: jobStatus.status === job_status_types_1.JobStatusEnum.FAILED || !!jobStatus?.result?.bledyImportu,
            isActive: jobStatus.status === job_status_types_1.JobStatusEnum.ACTIVE,
            isWaiting: jobStatus.status === job_status_types_1.JobStatusEnum.WAITING,
            isNotFound: jobStatus.status === job_status_types_1.JobStatusEnum.NOT_FOUND,
        };
    }, [jobStatus]);
};
exports.useJobState = useJobState;
